/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcFilterOnRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M21 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6M3 5.1h13.2c.013.638.15 1.246.39 1.8H3a.9.9 0 0 1 0-1.8m4 6a.9.9 0 1 0 0 1.8h10a.9.9 0 0 0 0-1.8zm3 6a.9.9 0 1 0 0 1.8h4a.9.9 0 0 0 0-1.8z" />
    </svg>
  );
}
export default IcFilterOnRegular;
